import { useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import { ArrowLeft, Clock, MapPin, Phone, ShieldCheck, Truck, Wrench } from "lucide-react";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { Footer } from "@/components/Footer";

export const CITIES = {
  "saint-priest": {
    name: "Saint-Priest",
    intro:
      "Un technicien SLH PHONE se déplace directement chez vous ou à votre bureau à Saint-Priest : centre-ville, Mi-Plaine, les Mûriers, Porte des Alpes, la zone Berliet ou le Parc Technologique. Écran cassé, batterie qui ne tient plus, téléphone qui ne charge plus : la réparation se fait sur place, sous vos yeux, en 1 heure environ.",
  },
  "villeurbanne": {
    name: "Villeurbanne",
    intro:
      "Un technicien SLH PHONE se déplace directement chez vous ou à votre bureau à Villeurbanne : Gratte-Ciel, Grandclément, Cusset, les Charmettes ou le campus de la Doua. Écran cassé, batterie qui ne tient plus, téléphone qui ne charge plus : la réparation se fait sur place, sous vos yeux, en 1 heure environ.",
  },
  "venissieux": {
    name: "Vénissieux",
    intro:
      "Un technicien SLH PHONE se déplace directement chez vous ou à votre bureau à Vénissieux : centre-ville, Parilly, les Minguettes ou la zone de Corbas. Écran cassé, batterie qui ne tient plus, téléphone qui ne charge plus : la réparation se fait sur place, sous vos yeux, en 1 heure environ.",
  },
  "bron": {
    name: "Bron",
    intro:
      "Un technicien SLH PHONE se déplace directement chez vous ou à votre bureau à Bron : centre-ville, Terraillon, le Parc de Parilly ou le Fort de Bron. Écran cassé, batterie qui ne tient plus, téléphone qui ne charge plus : la réparation se fait sur place, sous vos yeux, en 1 heure environ.",
  },
  "vaulx-en-velin": {
    name: "Vaulx-en-Velin",
    intro:
      "Un technicien SLH PHONE se déplace directement chez vous ou à votre bureau à Vaulx-en-Velin : Carré de Soie, La Grappinière, le centre ou le Planétarium. Écran cassé, batterie qui ne tient plus, téléphone qui ne charge plus : la réparation se fait sur place, sous vos yeux, en 1 heure environ.",
  },
  "oullins": {
    name: "Oullins",
    intro:
      "Un technicien SLH PHONE se déplace directement chez vous ou à votre bureau à Oullins : centre-ville, La Saulaie, Pierre-Bénite ou près de la gare d'Oullins. Écran cassé, batterie qui ne tient plus, téléphone qui ne charge plus : la réparation se fait sur place, sous vos yeux, en 1 heure environ.",
  },
  "decines-charpieu": {
    name: "Décines-Charpieu",
    intro:
      "Un technicien SLH PHONE se déplace directement chez vous ou à votre bureau à Décines-Charpieu : centre de Décines, le Grand Large ou autour du Groupama Stadium. Écran cassé, batterie qui ne tient plus, téléphone qui ne charge plus : la réparation se fait sur place, sous vos yeux, en 1 heure environ.",
  },
  "meyzieu": {
    name: "Meyzieu",
    intro:
      "Un technicien SLH PHONE se déplace directement chez vous ou à votre bureau à Meyzieu : centre-ville, le Parc du Grand Large ou près de la gare SNCF. Écran cassé, batterie qui ne tient plus, téléphone qui ne charge plus : la réparation se fait sur place, sous vos yeux, en 1 heure environ.",
  },
  "brignais": {
    name: "Brignais",
    intro:
      "Un technicien SLH PHONE se déplace directement chez vous ou à votre bureau à Brignais : centre-ville, la vallée de la Garon ou vers Givors et Vourles. Écran cassé, batterie qui ne tient plus, téléphone qui ne charge plus : la réparation se fait sur place, sous vos yeux, en 1 heure environ.",
  },
  "genas": {
    name: "Genas",
    intro:
      "Un technicien SLH PHONE se déplace directement chez vous ou à votre bureau à Genas : centre-ville, les zones d'activités ou vers l'aéroport Saint-Exupéry. Écran cassé, batterie qui ne tient plus, téléphone qui ne charge plus : la réparation se fait sur place, sous vos yeux, en 1 heure environ.",
  },
  "chassieu": {
    name: "Chassieu",
    intro:
      "Un technicien SLH PHONE se déplace directement chez vous ou à votre bureau à Chassieu : centre-ville, le parc d'activités ou près d'Eurexpo. Écran cassé, batterie qui ne tient plus, téléphone qui ne charge plus : la réparation se fait sur place, sous vos yeux, en 1 heure environ.",
  },
  "rillieux-la-pape": {
    name: "Rillieux-la-Pape",
    intro:
      "Un technicien SLH PHONE se déplace directement chez vous ou à votre bureau à Rillieux-la-Pape : centre-ville, Crépieux-la-Pape, Sermenaz ou vers le parc de la Feyssine. Écran cassé, batterie qui ne tient plus, téléphone qui ne charge plus : la réparation se fait sur place, sous vos yeux, en 1 heure environ.",
  },
  "givors": {
    name: "Givors",
    intro:
      "Un technicien SLH PHONE se déplace directement chez vous ou à votre bureau à Givors : centre-ville, les bords du Rhône ou la vallée du Gier. Écran cassé, batterie qui ne tient plus, téléphone qui ne charge plus : la réparation se fait sur place, sous vos yeux, en 1 heure environ.",
  },
  "corbas": {
    name: "Corbas",
    intro:
      "Un technicien SLH PHONE se déplace directement chez vous ou à votre bureau à Corbas : centre-ville, les zones d'activités ou vers Mions et Saint-Priest. Écran cassé, batterie qui ne tient plus, téléphone qui ne charge plus : la réparation se fait sur place, sous vos yeux, en 1 heure environ.",
  },
  "pierre-benite": {
    name: "Pierre-Bénite",
    intro:
      "Un technicien SLH PHONE se déplace directement chez vous ou à votre bureau à Pierre-Bénite : centre-ville, vers l'hôpital Lyon Sud ou Oullins. Écran cassé, batterie qui ne tient plus, téléphone qui ne charge plus : la réparation se fait sur place, sous vos yeux, en 1 heure environ.",
  },
};

export const POINTS = [
  "Intervention à domicile et au bureau",
  "Réparation en 1h : écran, batterie, connecteur de charge, caméra",
  "Diagnostic et devis gratuits avant toute intervention",
  "Déplacement offert sur toute la métropole",
  "Garantie 3 mois pièces et main d'œuvre",
  "Disponible de 10h à 23h, 7 jours sur 7",
];

export const CITY_SLUGS = Object.keys(CITIES);

export const CityPage = ({ citySlug }) => {
  const data = CITIES[citySlug];

  useEffect(() => {
    if (!data) return;
    document.title = `Réparation téléphone à domicile à ${data.name} | SLH PHONE`;
    const meta = document.querySelector('meta[name="description"]');
    meta?.setAttribute(
      "content",
      `Réparation de téléphone à domicile à ${data.name} : écran cassé, batterie, connecteur de charge, caméra. Intervention en 1h, déplacement offert, garantie 3 mois. De 10h à 23h, 7j/7.`
    );
    const canonical = document.querySelector('link[rel="canonical"]');
    canonical?.setAttribute("href", `https://slh-phone.fr/reparation-telephone-${citySlug}`);
    return () => {
      document.title = "Réparation téléphone à domicile à Lyon | SLH PHONE";
      meta?.setAttribute(
        "content",
        "Réparation à domicile ou au bureau iPhone & Samsung à Lyon et les alentours. Écran cassé, batterie, caméra... Pièces premium, garantie 3 mois. Intervention rapide de 10h à 23h, 7j/7."
      );
      canonical?.setAttribute("href", "https://slh-phone.fr/");
    };
  }, [data, citySlug]);

  if (!data) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="relative min-h-screen bg-[#E8F1FC] text-zinc-900 antialiased" data-testid="city-page">
      <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 h-[80px] flex items-center justify-between">
          <Link to="/" data-testid="city-back-home" aria-label="Retour à l'accueil SLH PHONE">
            <img src="/assets/logo.png" alt="Logo SLH PHONE" className="h-12 w-auto mix-blend-screen" />
          </Link>
          <a
            href="tel:+33651487403"
            className="flex items-center gap-2 rounded-full bg-[#0055FF] px-4 py-1.5 text-[10px] font-semibold uppercase tracking-[0.15em] text-white shadow-[0_0_20px_rgba(0,85,255,0.35)] hover:shadow-[0_0_30px_rgba(0,85,255,0.55)] transition-shadow duration-300"
            data-testid="city-phone-cta"
          >
            <Phone className="h-3 w-3" />
            06 51 48 74 03
          </a>
        </div>
      </header>

      <main className="pt-[80px]">
        <section className="max-w-7xl mx-auto px-6 lg:px-12 pt-16 lg:pt-24 pb-16">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-zinc-500 hover:text-[#0055FF] transition-colors duration-300 mb-10"
            data-testid="city-back-link"
          >
            <ArrowLeft className="h-4 w-4" /> Retour à l'accueil
          </Link>

          <h1 className="font-display font-black uppercase tracking-tighter leading-[0.95] text-[clamp(2rem,6vw,5rem)] text-zinc-950">
            Réparation téléphone
            <br />
            à domicile à <span className="text-[#0055FF]">{data.name}</span>
          </h1>

          <div className="blue-beam w-full max-w-md mt-8" aria-hidden="true" />

          <p className="mt-8 max-w-2xl text-base md:text-lg leading-relaxed font-light text-zinc-600" data-testid="city-intro">
            {data.intro}
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-5">
            <a
              href="/reservation"
              className="flex items-center gap-3 rounded-full bg-[#25D366] px-9 py-4 text-sm font-semibold uppercase tracking-[0.2em] text-white shadow-[0_0_24px_rgba(37,211,102,0.4)] hover:shadow-[0_0_36px_rgba(37,211,102,0.6)] transition-shadow duration-300"
              data-testid="city-whatsapp-cta"
            >
              Réserver
            </a>
            <a
              href="tel:+33651487403"
              className="rounded-full border border-zinc-300 px-9 py-4 text-sm font-semibold uppercase tracking-[0.2em] text-zinc-600 hover:border-zinc-900 hover:text-zinc-950 transition-colors duration-300"
              data-testid="city-call-cta"
            >
              06 51 48 74 03
            </a>
          </div>
        </section>

        <section className="bg-white border-y border-zinc-200 py-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight uppercase text-zinc-950 mb-12">
              Pourquoi choisir SLH PHONE à {data.name} ?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {POINTS.map((point, i) => {
                const Icon = [Truck, Wrench, ShieldCheck, MapPin, ShieldCheck, Clock][i % 6];
                return (
                  <div
                    key={i}
                    className="flex items-start gap-4 border border-zinc-200 bg-[#F6FAFF] p-6"
                    data-testid={`city-point-${i}`}
                  >
                    <Icon className="h-6 w-6 shrink-0 text-[#0055FF] mt-0.5" />
                    <p className="text-sm leading-relaxed text-zinc-700">{point}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight uppercase text-zinc-950 mb-8">
            Nos réparations à {data.name}
          </h2>
          <p className="max-w-2xl text-base leading-relaxed font-light text-zinc-600">
            iPhone, Samsung, Xiaomi, Google Pixel et la plupart des autres marques.
            Vitre et dalle remplacées, tactile et couleurs d'origine, joint
            d'étanchéité refait au remontage. Batterie neuve à 100 %, connecteur
            de charge nettoyé ou remplacé, caméra changée. Chaque réparation est
            réalisée avec soin et garantie 3 mois — déplacement offert sur{" "}
            {data.name}.
          </p>
          <div className="mt-8 flex flex-wrap gap-4" data-testid="city-repair-links">
            <Link
              to={`/reparation-ecran-${citySlug}`}
              className="rounded-full border border-zinc-300 px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-zinc-600 hover:border-[#0055FF] hover:text-[#0055FF] transition-colors duration-300"
              data-testid="city-link-ecran"
            >
              Réparation écran à {data.name}
            </Link>
            <Link
              to={`/reparation-batterie-${citySlug}`}
              className="rounded-full border border-zinc-300 px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-zinc-600 hover:border-[#0055FF] hover:text-[#0055FF] transition-colors duration-300"
              data-testid="city-link-batterie"
            >
              Batterie à {data.name}
            </Link>
          </div>
        </section>
      </main>

      <Footer onNavigate={(id) => (window.location.href = "/" + id)} />
      <WhatsAppButton />
    </div>
  );
};
